<template>
	<div>
		<div class="text-c mt-10 mb-10">
			<el-button @click="关闭页面()" :class="用户设置参数.编辑表单按钮尺寸" size="mini" type="danger" :loading="下单中">关闭下单页面
			</el-button>
			<el-button @click="下单()" :class="用户设置参数.编辑表单按钮尺寸" size="mini" type="primary" :loading="下单中">立即下单
			</el-button>
		</div>

		<el-form :model="订单表单" ref="订单表单" :rules="订单表单验证" :size="用户设置参数.编辑表单尺寸" label-width="auto">
			<mianban header="客户信息" yangshi="panel-primary" class="ma-10">
				<div>
					<el-row>
						<el-col :span="24">
							<el-form-item label="查询客户信息">
								<el-autocomplete v-model="订单表单.查询客户信息" :fetch-suggestions="查询客户信息"
									placeholder="请输入客户简称查询" @select="xuanze_kehuxinxi" :trigger-on-focus="false"
									style="width: 100%;"></el-autocomplete>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="8">
							<el-form-item label="客户名称" prop="客户名称" required>
								<el-input v-model="订单表单.客户名称" placeholder="请输入客户名称" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="客户编号" prop="客户编号" required>
								<el-input v-model="订单表单.客户编号" placeholder="请输入客户编号" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="联系人" prop="联系人" required>
								<el-input v-model="订单表单.联系人" placeholder="请输入联系人" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="8">
							<el-form-item label="订车人">
								<el-input v-model="订单表单.订车人" placeholder="请输入订车人"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="订车人手机">
								<el-input type="" v-model="订单表单.订车人手机" placeholder="请输入订车人手机"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="联系人手机" prop="联系人手机" required>
								<el-input v-model="订单表单.联系人手机" placeholder="请输入联系人手机" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
			</mianban>

			<mianban header="订单信息" yangshi="panel-secondary" class="ma-10">
				<div>
					<el-row>
						<el-col :span="6">
							<el-form-item label="订单状态" prop="订单状态" required>
								<el-input v-model="订单表单.订单状态" placeholder="请输入订单状态" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="订单分类" prop="订单分类" required>
								<el-input v-model="订单表单.订单分类" placeholder="请输入订单分类" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="订单类型" prop="订单类型" required v-if="false">
								<el-select v-model="订单表单.订单类型" placeholder="请选择订单类型" style="width: 100%;">
									<el-option v-for="item in 订单类型列表" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="车辆分类" prop="车辆分类" required>
								<el-select v-model="订单表单.车辆分类" multiple placeholder="请选择车辆分类" style="width: 100%;">
									<el-option v-for="item in 车辆分类列表" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="送车时间">
								<el-date-picker v-model="订单表单.送车时间" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="送车时间" style="width: 100%;">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<template>
						<el-row>
							<el-col :span="12">
								<el-form-item label="发车日期/结束日期" prop="日期范围" required>
									<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"
										v-model="订单表单.日期范围" type="datetimerange" align="right" start-placeholder="发车日期"
										end-placeholder="结束日期" :default-time="['08:00:00', '23:00:00']"
										:clearable="false"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="6" v-if="false">
								<el-form-item label="座位需求" prop="座位需求" required>
									<el-select v-model="订单表单.座位需求" multiple placeholder="请选择座位需求" style="width: 100%;">
										<el-option v-for="item in 座位需求列表" :key="item.value" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="品牌型号需求">
									<el-input v-model="订单表单.品牌型号需求" placeholder="多个用英文,分开"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="订单提成所属人" prop="订单提成所属人">
									<el-input v-model="订单表单.订单提成所属人" placeholder="多个用英文,分开"></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="6">
								<el-form-item :label="type=='散单' ? '几日':'几个月'" prop="几个月" required>
									<el-input-number style="width: 100%;" v-model="订单表单.几个月" :min="1" label="几个月"
										:precision="0"></el-input-number>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="业务员" prop="业务员" required>
									<el-input v-model="订单表单.业务员" placeholder="业务员"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="登单人" prop="登单人" required>
									<el-input v-model="订单表单.登单人" placeholder="请输入登单人" :disabled="true"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="订单数量" prop="订单数量" required>
									<el-input-number style="width: 100%;" v-model="订单表单.订单数量" :min="1" :max="100"
										label="订单数量" :precision="0"></el-input-number>
								</el-form-item>
							</el-col>

							<template v-if="订单表单.订单分类 == '班车' || 订单表单.订单分类 == '运通订单'">
								<el-col :span="6">
									<el-form-item label="公里数" prop="公里数" required>
										<el-input-number style="width: 100%;" v-model="订单表单.公里数" :precision="0"
											:step="100" :min="0" :max="999999999" :controls="false"></el-input-number>
									</el-form-item>
								</el-col>
							</template>
						</el-row>

						<template v-if="订单表单.订单分类 == '班车' || 订单表单.订单分类 == '运通订单'">
							<el-row>
								<el-col :span="12">
									<el-form-item label="线路编号" prop="线路编号">
										<template>
											<el-autocomplete v-model="订单表单.线路编号" placeholder="请输入线路编号"
												:fetch-suggestions="查询线路编号" @select="xuanze_xianlubianhao"
												style="width: 100%;"></el-autocomplete>
										</template>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="线路ID" prop="线路ID">
										<el-input v-model="订单表单.线路ID" placeholder="请输入线路ID"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="线路名" prop="线路名">
										<el-input v-model="订单表单.线路名" placeholder="请输入线路名"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
						</template>
						
						<template v-if="订单表单.订单分类 == '散单'">
							<el-row>
								<el-col :span="6">
									<el-form-item label="取车公里数" prop="取车公里数" required>
										<el-input-number style="width: 100%;" v-model="订单表单.取车公里数" :precision="0"
											:step="100" :min="0" :max="999999999" :controls="false"></el-input-number>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="还车公里数" prop="还车公里数" required>
										<el-input-number style="width: 100%;" v-model="订单表单.还车公里数" :precision="0"
											:step="100" :min="0" :max="999999999" :controls="false"></el-input-number>
									</el-form-item>
								</el-col>
								<el-col :span="6">
									<el-form-item label="实用公里数" prop="实用公里数" required>
										<el-input-number style="width: 100%;" v-model="订单表单.实用公里数" :precision="0" :controls="false" :disabled="true"></el-input-number>
									</el-form-item>
								</el-col>
							</el-row>
						</template>

						<el-row>
							<el-col :span="24">
								<el-form-item label="行程描述" prop="行程描述" required>
									<el-input type="textarea" :autosize="{ minRows: 3, maxRows: 10 }"
										v-model="订单表单.行程描述"
										placeholder="禁止任何空白字符，包括空格、制表符、换页符、逗号英文状态下的等等特殊符号,可以用中文输入状态下的特效符号代替"></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="24">
								<el-form-item label="备注">
									<el-input type="textarea" :autosize="{ minRows: 3, maxRows: 10 }" v-model="订单表单.备注"
										placeholder="请输入备注"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</template>


				</div>
			</mianban>

			<mianban header="车辆信息" yangshi="panel-success" class="ma-10">
				<div slot="header">车辆信息
					<el-button @click="添加车辆()" class="ml-10" :class="用户设置参数.编辑表单按钮尺寸" type="warning" size="mini">添加车辆
					</el-button>
				</div>
				<div>
					<div v-for="(v, k) in 订单表单.车辆信息" :key="v.key">
						<el-divider><span class="f-16">车辆{{k+1}}</span>
							<el-button @click.prevent="删除车辆(v)" class="ml-10" :class="用户设置参数.编辑表单按钮尺寸" type="danger"
								size="mini">删除</el-button>
						</el-divider>
						<el-row>
							<el-col :span="24">
								<el-form-item label="车牌号码" :prop="'车辆信息.' + k + '.车牌号码'" required
									:rules="{required: true, message: '不能为空', trigger: 'blur'}">
									<template>
										<el-autocomplete v-model="v.车牌号码" placeholder="请输入车牌号码"
											:fetch-suggestions="查询车牌号码" @select="xuanze_chepaihaoma(v)"
											style="width: 100%;">
										</el-autocomplete>
									</template>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="车主单位" :prop="'车辆信息.' + k + '.车主单位'" required
									:rules="{required: true, message: '不能为空', trigger: 'blur'}">
									<el-input v-model="v.车主单位" placeholder="请输入车主单位"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="品牌型号" :prop="'车辆信息.' + k + '.品牌型号'" required
									:rules="{required: true, message: '不能为空', trigger: 'blur'}">
									<el-input v-model="v.品牌型号" placeholder="请输入品牌型号"></el-input>
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="座位数" :prop="'车辆信息.' + k + '.座位数'" required
									:rules="{required: true, message: '不能为空', trigger: 'blur'}">
									<el-input v-model="v.座位数" placeholder="请输入座位数"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="车架号">
									<el-input v-model="v.车架号" placeholder="请输入车架号"></el-input>
								</el-form-item>
							</el-col>
							
							<el-col :span="6">
								<el-form-item :label="type=='散单' ? '日租金':'月租金'" :prop="'车辆信息.' + k + '.月租金'" required
									:rules="{required: true, message: '不能为空', trigger: 'blur'}">
									<el-input-number style="width: 100%;" v-model="v.月租金" :precision="2" :step="100"
										:min="0.0" :max="999999999.99" :controls="false" @change="计算应收费用()"
										:disabled="type=='免费单'">
									</el-input-number>
								</el-form-item>
							</el-col>
							
							<el-col :span="6">
								<el-form-item label="超时费" :prop="'车辆信息.' + k + '.超时费'" required
									:rules="{required: true, message: '不能为空', trigger: 'blur'}">
									<el-input-number style="width: 100%;" v-model="v.超时费" :precision="2" :step="100"
										:min="0.0" :max="999999999.99" :controls="false" @change="计算应收费用()"
										:disabled="type=='免费单'">
									</el-input-number>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="超公里费" :prop="'车辆信息.' + k + '.超公里费'" required
									:rules="{required: true, message: '不能为空', trigger: 'blur'}">
									<el-input-number style="width: 100%;" v-model="v.超公里费" :precision="2" :step="100"
										:min="0.0" :max="999999999.99" :controls="false" @change="计算应收费用()"
										:disabled="type=='免费单'">
									</el-input-number>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="其他费" :prop="'车辆信息.' + k + '.其他费'" required
									:rules="{required: true, message: '不能为空', trigger: 'blur'}">
									<el-input-number style="width: 100%;" v-model="v.其他费" :precision="2" :step="100"
										:min="0.0" :max="999999999.99" :controls="false" @change="计算应收费用()"
										:disabled="type=='免费单'">
									</el-input-number>
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="驾驶员">
									<el-input v-model="v.驾驶员" placeholder="请输入驾驶员"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="驾驶员手机">
									<el-input v-model="v.驾驶员手机" placeholder="请输入驾驶员手机"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						
					</div>
				</div>
			</mianban>

			<mianban header="费用信息" yangshi="panel-danger" class="ma-10">
				<div>
					<el-row>
						<el-col :span="6">
							<el-form-item label="应收费用" prop="应收费用" required>
								<el-input-number style="width: 100%;" v-model="订单表单.应收费用" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false" disabled></el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="业务费用" prop="业务费用" required>
								<el-input-number style="width: 100%;" v-model="订单表单.业务费用" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false" @change="业务费用输入(订单表单.业务费用)"
									:disabled="type=='免费单'">
								</el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="应付外调车租" prop="应付外调车租" required>
								<el-input-number style="width: 100%;" v-model="订单表单.应付外调车租" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false" @change="应付外调车租输入(订单表单.应付外调车租)"
									:disabled="type=='免费单'">
								</el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="付款方式" prop="付款方式" required>
								<el-select v-model="订单表单.付款方式" placeholder="请选择付款方式" style="width: 100%;">
									<el-option v-for="item in 付款方式列表" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="收款状态" prop="收款状态" required>
								<el-input v-model="订单表单.收款状态" placeholder="请输入收款状态" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="业务费用付款状态" prop="业务费用付款状态" required>
								<el-input v-model="订单表单.业务费用付款状态" placeholder="请输入业务费用付款状态" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="外调付款状态" prop="外调付款状态" required>
								<el-input v-model="订单表单.外调付款状态" placeholder="请输入外调付款状态" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="业务助理">
								<el-input v-model="订单表单.业务助理" placeholder="请输入业务助理"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="包路桥费">
								<el-radio-group v-model="订单表单.包路桥费">
									<el-radio label="是" border>是</el-radio>
									<el-radio label="否" border>否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="包油费">
								<el-radio-group v-model="订单表单.包油费">
									<el-radio label="是" border>是</el-radio>
									<el-radio label="否" border>否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="包停车费">
								<el-radio-group v-model="订单表单.包停车费">
									<el-radio label="是" border>是</el-radio>
									<el-radio label="否" border>否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="包其它费">
								<el-radio-group v-model="订单表单.包其它费">
									<el-radio label="是" border>是</el-radio>
									<el-radio label="否" border>否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="开票情况" prop="开票情况" required>
								<el-select v-model="订单表单.开票情况" placeholder="请选择开票情况" style="width: 100%;">
									<el-option v-for="item in 开票情况列表" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="油卡编号">
								<el-select v-model="订单表单.油卡编号" filterable placeholder="请选择" style="width: 100%;">
									<el-option label="不绑定" value=""></el-option>
									<el-option v-for="v in 油卡列表" :key="v" :label="v"
										:value="v">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="计算业务费用" prop="计算业务费用" required>
								<el-select v-model="订单表单.计算业务费用" placeholder="请选择" style="width: 100%;">
									<el-option label="计算" value="计算"></el-option>
									<el-option label="不计算" value="不计算"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						
					</el-row>

					<el-row>
						<el-col :span="24">
							<el-form-item label="付款说明">
								<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="订单表单.付款说明"
									placeholder="请输入付款说明"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="租车押金状态" prop="租车押金状态" required>
								<el-select v-model="订单表单.租车押金状态" placeholder="请选择租车押金状态" style="width: 100%;">
									<el-option label="不收取" value="不收取"></el-option>
									<el-option label="已收取" value="已收取"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="租车押金" prop="租车押金" required>
								<el-input-number style="width: 100%;" v-model="订单表单.租车押金" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false"></el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="违章押金状态" prop="违章押金状态" required>
								<el-select v-model="订单表单.违章押金状态" placeholder="请选择违章押金状态" style="width: 100%;">
									<el-option label="不收取" value="不收取"></el-option>
									<el-option label="已收取" value="已收取"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="违章押金" prop="违章押金" required>
								<el-input-number style="width: 100%;" v-model="订单表单.违章押金" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false"></el-input-number>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
			</mianban>

			<mianban header="收车后确认司机垫付的费用" yangshi="panel-warning" class="ma-10">
				<div>
					<el-row>
						<el-col :span="6">
							<el-form-item label="路桥费" prop="路桥费" required>
								<el-input-number style="width: 100%;" v-model="订单表单.路桥费" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false" @change="计算收车后确认司机垫付的费用()">
								</el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="停车费" prop="停车费" required>
								<el-input-number style="width: 100%;" v-model="订单表单.停车费" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false"></el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="油费" prop="油费" required>
								<el-input-number style="width: 100%;" v-model="订单表单.油费" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false"></el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="食宿费" prop="食宿费" required>
								<el-input-number style="width: 100%;" v-model="订单表单.食宿费" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false"></el-input-number>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="出车补助" prop="出车补助" required>
								<el-input-number style="width: 100%;" v-model="订单表单.出车补助" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false"></el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="其它费" prop="其它费" required>
								<el-input-number style="width: 100%;" v-model="订单表单.其它费" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false"></el-input-number>
							</el-form-item>
						</el-col>
						
<!-- 						<el-col :span="6">
							<el-form-item label="超时费" prop="超时费" required>
								<el-input-number style="width: 100%;" v-model="订单表单.超时费" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false"></el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="超公里费" prop="超公里费" required>
								<el-input-number style="width: 100%;" v-model="订单表单.超公里费" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false"></el-input-number>
							</el-form-item>
						</el-col>

						<el-col :span="6">
							<el-form-item label="充电费" prop="充电费" required>
								<el-input-number style="width: 100%;" v-model="订单表单.充电费" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false"></el-input-number>
							</el-form-item>
						</el-col> -->
						
						<el-col :span="6">
							<el-form-item label="费用合计" prop="费用合计" required>
								<el-input-number style="width: 100%;" v-model="订单表单.费用合计" :precision="2" :step="100"
									:min="0.0" :max="999999999.99" :controls="false" disabled>
								</el-input-number>
							</el-form-item>
						</el-col>
					</el-row>
					
				</div>
			</mianban>
		</el-form>



		<div class="text-c mt-20 mb-50">
			<el-button @click="关闭页面()" :class="用户设置参数.编辑表单按钮尺寸" size="mini" type="danger" :loading="下单中">关闭下单页面
			</el-button>
			<el-button @click="下单()" :class="用户设置参数.编辑表单按钮尺寸" size="mini" type="primary" :loading="下单中">立即下单
			</el-button>
		</div>


	</div>
</template>

<script>
	export default {
		name: 'dingdan-add',
		props: {
			type: String
		},
		data() {
			return {
				用户设置参数: JSON.parse(localStorage.getItem('用户设置参数')),
				下单中: false,
				订单表单: {
					几个月: 1,
					订单数量: 1,
					查询客户信息: '',
					客户名称: '',
					客户编号: '',
					联系人: '',
					联系人手机: '',
					订车人: '',
					订车人手机: '',
					订单状态: '未确认',
					订单分类: this.type,
					订单类型: '一天',
					车辆分类: [],
					日期范围: [],
					发车日期: '',
					结束日期: '',
					座位需求: [],
					品牌型号需求: '',
					订单提成所属人: '',
					业务员: '',
					登单人: '',
					登单日期: '',
					公里数: 0,
					取车公里数: 0,
					还车公里数: 0,
					实用公里数: 0,
					线路编号: '',
					线路ID: '',
					线路名: '',
					行程描述: '',
					备注: '',
					应收费用: '',
					业务费用: '',
					应付外调车租: '',
					实际收款金额: '',
					收款状态: '未收款',
					业务费用付款状态: '无需付款',
					外调付款状态: '无需付款',
					欠费: '',
					收款日期: '',
					付款方式: '',
					开票情况: '不开票',
					业务助理: '',
					包路桥费: '否',
					包油费: '否',
					包停车费: '否',
					包其它费: '否',
					付款说明: '',
					租车押金状态: '不收取',
					租车押金: '',
					违章押金状态: '不收取',
					违章押金: '',
					车辆信息: [],
					路桥费: '',
					停车费: '',
					油费: '',
					食宿费: '',
					出车补助: '',
					其它费: '',
					// 超时费: '',
					// 超公里费: '',
					// 充电费: '',
					费用合计: '',
					油卡编号: '',
					送车时间: null,
					计算业务费用: '计算',
				},
				订单表单验证: {
					客户名称: [{
						required: true,
						message: '客户名称不能为空',
						trigger: 'blur'
					}],
					客户编号: [{
						required: true,
						message: '客户编号不能为空',
						trigger: 'blur'
					}],
					联系人: [{
						required: true,
						message: '联系人不能为空',
						trigger: 'blur'
					}],
					联系人手机: [{
							required: true,
							message: '请输入联系人手机',
							trigger: 'blur'
						},
						{
							pattern: /^1\d{10}$/,
							message: '请输入正确的11位手机号码',
							trigger: 'blur'
						}
					],
					日期范围: [{
						required: true,
						message: '发车日期/结束日期不能为空',
						trigger: 'blur'
					}],
					座位需求: [{
						required: true,
						message: '座位需求不能为空',
						trigger: 'blur'
					}],
					业务员: [{
						required: true,
						message: '业务员不能为空',
						trigger: 'blur'
					}],
					订单类型: [{
						required: true,
						message: '订单类型不能为空',
						trigger: 'blur'
					}],
					车辆分类: [{
						required: true,
						message: '车辆分类不能为空',
						trigger: 'blur'
					}],
					行程描述: [{
						required: true,
						message: '行程描述不能为空',
						trigger: 'blur'
					}],
					应收费用: [{
						required: true,
						message: '应收费用不能为空',
						trigger: 'blur'
					}],
					业务费用: [{
						required: true,
						message: '业务费用不能为空',
						trigger: 'blur'
					}],
					应付外调车租: [{
						required: true,
						message: '应付外调车租不能为空',
						trigger: 'blur'
					}],
					业务费用付款状态: [{
						required: true,
						message: '业务费用付款状态不能为空',
						trigger: 'blur'
					}],
					外调付款状态: [{
						required: true,
						message: '外调付款状态不能为空',
						trigger: 'blur'
					}],
					付款方式: [{
						required: true,
						message: '付款方式不能为空',
						trigger: 'blur'
					}],
					开票情况: [{
						required: true,
						message: '开票情况不能为空',
						trigger: 'blur'
					}],
					租车押金状态: [{
						required: true,
						message: '租车押金状态不能为空',
						trigger: 'blur'
					}],
					租车押金: [{
						required: true,
						message: '租车押金不能为空',
						trigger: 'blur'
					}],
					违章押金状态: [{
						required: true,
						message: '违章押金状态不能为空',
						trigger: 'blur'
					}],
					违章押金: [{
						required: true,
						message: '违章押金不能为空',
						trigger: 'blur'
					}],
					计算业务费用: [{
						required: true,
						message: '计算业务费用不能为空',
						trigger: 'blur'
					}]
					
				},

				订单类型列表: [],
				车辆分类列表: [],
				座位需求列表: [],
				业务员列表: [],
				付款方式列表: [],
				开票情况列表: [],
				油卡列表: [],
			};
		},
		created: function() {
			this.获取默认参数();
		},
		watch: {
			'订单表单.路桥费'() {
				this.计算收车后确认司机垫付的费用()
			},
			'订单表单.停车费'() {
				this.计算收车后确认司机垫付的费用()
			},
			'订单表单.油费'() {
				this.计算收车后确认司机垫付的费用()
			},
			'订单表单.食宿费'() {
				this.计算收车后确认司机垫付的费用()
			},
			'订单表单.出车补助'() {
				this.计算收车后确认司机垫付的费用()
			},
			'订单表单.其它费'() {
				this.计算收车后确认司机垫付的费用()
			},
			// '订单表单.超时费'() {
			// 	this.计算收车后确认司机垫付的费用()
			// },
			// '订单表单.超公里费'() {
			// 	this.计算收车后确认司机垫付的费用()
			// },
			// '订单表单.充电费'() {
			// 	this.计算收车后确认司机垫付的费用()
			// },

			'订单表单.几个月'() {
				this.计算应收费用()
			},
			'订单表单.业务费用'() {
				this.计算应收费用()
			},
			'订单表单.应付外调车租'() {
				this.计算应收费用()
			},
			'订单表单.计算业务费用'() {
				this.计算应收费用()
			},
			
			'订单表单.取车公里数'() {
				this.计算实用公里数()
			},
			'订单表单.还车公里数'() {
				this.计算实用公里数()
			},
				
		},
		methods: {
			计算实用公里数() {
				this.订单表单.实用公里数 =
					Number(this.订单表单.还车公里数) -
					Number(this.订单表单.取车公里数);
			},
			下单() {
				let len = this.订单表单.日期范围.length;
				if (len === 2) {
					this.订单表单.发车日期 = this.订单表单.日期范围[0];
					this.订单表单.结束日期 = this.订单表单.日期范围[1];
				} else {
					this.$message.error('发车日期/结束日期错误');
					return false;
				}
				this.下单中 = true;
				this.$refs['订单表单'].validate(valid => {
					if (valid) {
						this.$http
							.post('dingdan/gg/add_submit', this.订单表单)
							.then(response => {
								this.$message.success(response.信息);
								this.$emit('shuaxin_sandan');
								this.关闭页面();
								this.下单中 = false;
							})
							.catch(error => {
								this.下单中 = false;
								console.log(error);
							});
					} else {
						//console.log(this.订单表单);
						this.$message.error('请检查是否填完');
						console.log('下单验证不通过，请检查下单信息是否正确!');
						this.下单中 = false;
						return false;
					}
				});
			},
			计算应收费用() {
				// console.log('计算应收费用');
				let len = this.订单表单.车辆信息.length;
				let 合计 = 0;
				// console.log(合计);
				if (len > 0) {
					for (let v of this.订单表单.车辆信息) {
						// console.log(v);
						合计 += Number(v.月租金) * Number(this.订单表单.几个月);
						合计 += Number(v.超时费) + Number(v.超公里费) + Number(v.其他费);
					}
				}
				if(this.订单表单.计算业务费用==='计算'){
					合计 += Number(this.订单表单.业务费用);
				}
				// console.log(合计);
				合计 += Number(this.订单表单.应付外调车租);
				// console.log(合计);
				this.订单表单.应收费用 = 合计;
			},
			计算收车后确认司机垫付的费用() {
				this.订单表单.费用合计 =
					Number(this.订单表单.路桥费) +
					Number(this.订单表单.停车费) +
					Number(this.订单表单.油费) +
					Number(this.订单表单.食宿费) +
					Number(this.订单表单.出车补助) +
					// Number(this.订单表单.超时费) +
					// Number(this.订单表单.超公里费) +
					// Number(this.订单表单.充电费) +
					Number(this.订单表单.其它费);
			},
			删除车辆(v) {
				this.$confirm('确定要删除 ' + v.车牌号码 + ' 吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var k = this.订单表单.车辆信息.indexOf(v)
					if (k !== -1) {
						this.订单表单.车辆信息.splice(k, 1);
						this.$message.success('删除成功');
					}
				}).catch(() => {
					this.$message.info('已取消删除');
				});
			},
			添加车辆() {
				this.订单表单.车辆信息.push({
					车牌号码: '',
					车主单位: '',
					品牌型号: '',
					驾驶员: '',
					驾驶员手机: '',
					座位数: '',
					月租金: 0,
					超时费: 0,
					超公里费: 0,
					其他费: 0,
					车架号: '',
					key: Date.now()
				});
			},
			获取默认参数() {
				this.$http.post('get/dingdan/list').then(返回数据 => {
					if (this.type == '免费单') {
						this.订单表单.收款状态 = '已收全款';
					}
					this.订单表单.登单人 = 返回数据.登单人;
					this.油卡列表 = 返回数据.油卡列表;
					
					let 订单类型数组 = 返回数据.订单类型;
					let 订单类型数组长度 = 订单类型数组.length;
					for (let i = 0; i < 订单类型数组长度; i++) {
						this.订单类型列表.push({
							value: 订单类型数组[i],
							label: 订单类型数组[i]
						});
					}

					let 车辆分类数组 = 返回数据.车辆分类;
					let 车辆分类数组长度 = 车辆分类数组.length;
					for (let i = 0; i < 车辆分类数组长度; i++) {
						this.车辆分类列表.push({
							value: 车辆分类数组[i],
							label: 车辆分类数组[i]
						});
					}

					let 座位需求数组 = 返回数据.座位需求;
					let 座位需求数组长度 = 座位需求数组.length;
					for (let i = 0; i < 座位需求数组长度; i++) {
						this.座位需求列表.push({
							value: 座位需求数组[i],
							label: 座位需求数组[i]
						});
					}

					let 业务员数组 = 返回数据.业务员;
					let 业务员数组长度 = 业务员数组.length;
					for (let i = 0; i < 业务员数组长度; i++) {
						this.业务员列表.push({
							value: 业务员数组[i],
							label: 业务员数组[i]
						});
					}

					let 付款方式数组 = 返回数据.付款方式;
					let 付款方式数组长度 = 付款方式数组.length;
					for (let i = 0; i < 付款方式数组长度; i++) {
						this.付款方式列表.push({
							value: 付款方式数组[i],
							label: 付款方式数组[i]
						});
					}

					let 开票情况数组 = 返回数据.开票情况;
					let 开票情况数组长度 = 开票情况数组.length;
					for (let i = 0; i < 开票情况数组长度; i++) {
						this.开票情况列表.push({
							value: 开票情况数组[i],
							label: 开票情况数组[i]
						});
					}
				});
			},

			查询客户信息(queryString, cb) {
				if (queryString != '') {
					this.$http
						.post('get/kehuziliao/kehumingcheng', {
							搜索值: queryString
						})
						.then(返回数据 => {
							let 客户信息列表 = new Array();
							let 客户信息数组 = 返回数据.客户信息;
							let 客户信息数组长度 = 客户信息数组.length;
							for (let i = 0; i < 客户信息数组长度; i++) {
								客户信息列表.push({
									value: 客户信息数组[i]
								});
							}
							cb(客户信息列表);
						});
				}
			},
			xuanze_kehuxinxi(item) {
				//console.log(item.value);
				this.订单表单.查询客户信息 = '';
				this.订单表单.客户名称 = item.value.客户简称;
				this.订单表单.客户编号 = item.value.客户编号;
				this.订单表单.联系人 = item.value.联系人姓名;
				this.订单表单.联系人手机 = item.value.联系人手机;
			},
			查询线路编号(queryString, cb) {
				if (queryString != '') {
					this.$http
						.post('get/banchexianlu/banchexianlu', {
							搜索值: queryString
						})
						.then(返回数据 => {
							let 线路编号列表 = new Array();
							let 线路编号数组 = 返回数据.班车线路;
							let 线路编号数组长度 = 线路编号数组.length;
							for (let i = 0; i < 线路编号数组长度; i++) {
								线路编号列表.push({
									value: 线路编号数组[i]
								});
							}
							cb(线路编号列表);
						});
				}
			},
			xuanze_xianlubianhao(item) {
				//console.log(item.value);
				this.订单表单.线路编号 = item.value.线路编号;
				this.订单表单.线路ID = item.value.线路ID;
				this.订单表单.线路名 = item.value.线路名;
			},
			关闭页面() {
				//console.log(111);
				this.$emit('close', false);
			},
			查询车牌号码(queryString, cb) {
				if (queryString != '') {
					this.$http
						.post('get/cheliangxinxi/cheliangxinxi3', {
							车牌号码: queryString
						})
						.then(返回数据 => {
							//console.log(返回数据);
							let 车辆信息列表 = new Array();
							let 车辆信息数组 = 返回数据.车辆信息;
							let 车辆信息数组长度 = 车辆信息数组.length;
							for (let i = 0; i < 车辆信息数组长度; i++) {
								车辆信息列表.push({
									value: 车辆信息数组[i]
								});
							}
							cb(车辆信息列表);
						});
				}
			},
			xuanze_chepaihaoma(v) {
				console.log(v);
				let k = this.订单表单.车辆信息.indexOf(v);
				let vv = v.车牌号码;
				vv.月租金 = v.月租金;
				vv.超时费 = v.超时费;
				vv.超公里费 = v.超公里费;
				vv.其他费 = v.其他费;
				this.订单表单.车辆信息.splice(k, 1, vv);
			},

			应付外调车租输入(value) {
				if (value > 0) {
					this.订单表单.外调付款状态 = '未付款';
				} else {
					this.订单表单.外调付款状态 = '无需付款';
				}
			},
			业务费用输入(value) {
				if (value > 0) {
					this.订单表单.业务费用付款状态 = '未付款';
				} else {
					this.订单表单.业务费用付款状态 = '无需付款';
				}
			},
		}
	};
</script>

<style scoped>
	.el-radio.is-bordered+.el-radio.is-bordered {
		margin-left: 0px;
	}
</style>
